import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getConfig } from '@/config/runtime-config';
import { handleOidcSilentCallback } from '@/services/oidcService';

const OIDC_SILENT_CALLBACK_LOCK_PREFIX = 'oidc:silent-callback:processed:';

const OidcSilentCallbackPage = () => {
  const location = useLocation();
  const [message, setMessage] = useState('Completing silent sign-in...');

  useEffect(() => {
    const callbackKey = `${OIDC_SILENT_CALLBACK_LOCK_PREFIX}${location.pathname}${location.search}`;

    if (globalThis.sessionStorage.getItem(callbackKey)) {
      return;
    }

    globalThis.sessionStorage.setItem(callbackKey, 'true');

    const processCallback = async () => {
      try {
        await handleOidcSilentCallback(getConfig());
        setMessage('Silent sign-in complete.');
      } catch (callbackError) {
        console.error('[OIDC Auth] Silent callback failed:', callbackError);
        setMessage('Silent sign-in failed.');
      }
    };

    void processCallback();
  }, [location.pathname, location.search]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}
    >
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
};

export default OidcSilentCallbackPage;